<script setup>
import {computed} from 'vue'

// Component Imports
import ThemesEditorSectionMenu from './ThemesEditorSectionMenu'
import ThemesEditorCssGroupsMenu from './ThemesEditorCssGroupsMenu'
import ThemesEditorAddBtn from './ThemesEditorAddBtn'
import ThemesEditorSearchBtn from './ThemesEditorSearchBtn'
import ThemesEditorNavSection from './ThemesEditorNavSection'
import Button from "@/common/Button.vue"
import {useThemesStore} from '@/stores/themes'

const themesStore = useThemesStore()

// --- Computed ---

const activeCssGroupName = computed(() => themesStore.activeCssGroupName)
const activeEditorKey = computed(() => themesStore.activeEditorKey)
const cssGroupNames = computed(() => themesStore.cssGroupNames)
const items = computed(() => themesStore.items)
const sectionName = computed(() => themesStore.sectionName)
const tableName = computed(() => themesStore.tableName)
</script>

<template>
    <div class="h-100 px-2">
        <header class="d-flex align-items-center py-2">

            <div class="flex-fill">
                <ThemesEditorSectionMenu/>
                <ThemesEditorCssGroupsMenu/>
            </div>

            <div class="dropdown">
                <Button class="btn-sm" data-bs-toggle="dropdown">
                    <i class="bi-three-dots"/>
                </Button>

                <div class="dropdown-menu dropdown-menu-end">
                    <ThemesEditorAddBtn/>
                    <ThemesEditorSearchBtn/>
                </div>
            </div>
        </header>

        <ThemesEditorNavSection/>
    </div>
</template>